/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Button } from '@mui/material';
import DialogContainer from '../../../../../../../components/shared/Dialog/DialogContainer';
import OrgAuthProviderCreation from './OrgAuthProviderCreation';

const OrgAuthProviderCreationBtn = () => {
    const [openCreationModal, setOpenCreationModal] = useState(false);
    const handleCloseDialog = () => {
        setOpenCreationModal(false)
    }
    return (
        <>
            <Button variant="contained" sx={{ background: (theme) => theme.palette.gradiant.main, float: 'right' }}
                onClick={() => setOpenCreationModal(true)} >Register Organization Identity Provider</Button>
            <DialogContainer
                open={openCreationModal}
                handleClose={handleCloseDialog}
            >
                <OrgAuthProviderCreation handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default OrgAuthProviderCreationBtn;